import { BaseRouteService } from 'core/services';

class PackingSlipRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'packing-slip/';
	}

	generatePdf(id) {
		return super.get(this.base + 'generate/{id}', id);
	}
}

export default PackingSlipRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/PackingSlipRouteService.js